import axios from "axios";
import Config from "../../../config/index";
import {
  CREATE_DPPDOCUMENTS_FAILURE,
  CREATE_DPPDOCUMENTS_REQUEST,
  CREATE_DPPDOCUMENTS_SUCCESS,
  EDIT_DOCUMENTS_FAILURE,
  EDIT_DOCUMENTS_REQUEST,
  EDIT_DOCUMENTS_SUCCESS,
  GET_DELETE_DOCUMENTS_FAILURE,
  GET_DELETE_DOCUMENTS_REQUEST,
  GET_DELETE_DOCUMENTS_SUCCESS,
  GET_DPP_DOCUMENTS_FAILURE,
  GET_DPP_DOCUMENTS_REQUEST,
  GET_DPP_DOCUMENTS_SUCCESS,
  UPLOAD_DOCUMENTS_FAILURE,
  UPLOAD_DOCUMENTS_REQUEST,
  UPLOAD_DOCUMENTS_SUCCESS,
  UPLOAD_IMAGES_FAILURE,
  UPLOAD_IMAGES_REQUEST,
  UPLOAD_IMAGES_SUCCESS,
} from "./documentsTypes";

let baseUrl = Config.baseUrl;

const getDppDocumentsRequest = () => {
  return {
    type: GET_DPP_DOCUMENTS_REQUEST,
  };
};

const getDppDocumentsSuccess = (payload) => {
  return {
    type: GET_DPP_DOCUMENTS_SUCCESS,
    payload: payload,
  };
};

const getDppDocumentsFailure = (error) => {
  return {
    type: GET_DPP_DOCUMENTS_FAILURE,
    payload: error,
  };
};
const getDppDocuments = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getDppDocumentsRequest());

    let url;

    // If dppId is provided → call specific endpoint with query param
    if (dppId) {
      url = `${baseUrl}/dpp/get_technical_documents_bydpp?dppId=${dppId}`;
    } else {
      // Otherwise → call general endpoint
      url = `${baseUrl}/dpp/get_technical_documents`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getDppDocumentsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getDppDocumentsFailure(err.message));
      });
  };
};

const getDppDocumentsImageRequest = () => {
  return {
    type: UPLOAD_IMAGES_REQUEST,
  };
};

const getDppDocumentsImageSuccess = (payload) => {
  return {
    type: UPLOAD_IMAGES_SUCCESS,
    payload: payload,
  };
};

const getDppDocumentsImageFailure = (error) => {
  return {
    type: UPLOAD_IMAGES_FAILURE,
    payload: error,
  };
};
const getDppDocumentsImage = (moduleName,type,name, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getDppDocumentsImageRequest());

 
    let url = `${baseUrl}/dpp/s3_documents?moduleName=${moduleName}&type=${type}&name=${name}`;
    console.log(url)
    axios
      .get(url, headers)
      .then((response) => {
        console.log("response",response)
        dispatch(getDppDocumentsImageSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getDppDocumentsImageFailure(err.message));
      });
  };
};

const deleteDppDocumentsRequest = () => {
  return {
    type: GET_DELETE_DOCUMENTS_REQUEST,
  };
};

const deleteDppDocumentsSuccess = (payload) => {
  return {
    type: GET_DELETE_DOCUMENTS_SUCCESS,
    payload: payload,
  };
};

const deleteDppDocumentsFaliure = (error) => {
  return {
    type: GET_DELETE_DOCUMENTS_FAILURE,
    payload: error,
  };
};

const deleteDppDocuments = (docId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(deleteDppDocumentsRequest());
    // let url = `${baseUrl}/dpp/product_passport/delete?dppId=${dppId}`;

    let url = `${baseUrl}/dpp/delete_technical_documents?docId=${docId}`;
    // let url = `${baseUrl}/mvtmap?id=${productId}`;
    // let url = `/mvtmap?id=334`;
    return axios
      .delete(url, {}, headers)
      .then((response) => {
        dispatch(deleteDppDocumentsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteDppDocumentsFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createDppDocumentsRequest = () => {
  return {
    type: CREATE_DPPDOCUMENTS_REQUEST,
  };
};

const createDppDocumentsSuccess = (payload) => {
  return {
    type: CREATE_DPPDOCUMENTS_SUCCESS,
    payload: payload,
  };
};

const createDppDocumentsFailure = (error) => {
  return {
    type: CREATE_DPPDOCUMENTS_FAILURE,
    payload: error,
  };
};

const createDppDocuments = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createDppDocumentsRequest());
    let url = `${baseUrl}/dpp/upload_technical_documents`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createDppDocumentsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createDppDocumentsFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const editDocumentsRequest = () => {
  return {
    type: EDIT_DOCUMENTS_REQUEST,
  };
};

const editDocumentsSuccess = (payload) => {
  return {
    type: EDIT_DOCUMENTS_SUCCESS,
    payload: payload,
  };
};

const editDocumentsFailure = (error) => {
  return {
    type: EDIT_DOCUMENTS_FAILURE,
    payload: error,
  };
};

const editDocuments = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(editDocumentsRequest());
    let url = `${baseUrl}/dpp/update_technical_documents`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(editDocumentsSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editDocumentsFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const uploadForDocumentsRequest = () => {
  return {
    type: UPLOAD_DOCUMENTS_REQUEST,
  };
};

const uploadForDocumentsSuccess = (payload) => {
  return {
    type: UPLOAD_DOCUMENTS_SUCCESS,
    payload: payload,
  };
};

const uploadForDocumentsFailure = (error) => {
  return {
    type: UPLOAD_DOCUMENTS_FAILURE,
    payload: error,
  };
};

const uploadForDocuments = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadForDocumentsRequest());
    let url = `${baseUrl}/dpp/technical_documents/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadForDocumentsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadForDocumentsFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


export {
  getDppDocuments,
  deleteDppDocuments,
  createDppDocuments,
    editDocuments,
    uploadForDocuments,
    getDppDocumentsImage
  //  getDocumentTypeWithPagination
  //  , createDocumentType
};
